import ProductGroupHelper from "../ProductGroupHelper";
import {canBePickedUp} from "../../libraries/utils";
import {generateDifferentiatedGroups} from "../ProductSelectionHelper";
import {getMenuProductsList} from "../../store/MenuItemsExternalStorage";

export const getMenuItem = (productId, self) => {
	if (self.featureToggles.singleProductToMenuUpgrade) {
		const menuProduct = (getMenuProductsList() || []).find(product => {
			const mainGroup = product.groups && product.groups.find(group => {
				return ProductGroupHelper.isMainProductGroup(group);
			});
			return mainGroup ?
				ProductGroupHelper.getSubProduct(mainGroup).id === productId
				&& canBePickedUp(product, self.productCatalog, self.cachedPickupRules, self.globalSelectedShop.id)
				: null;
		});
		if (menuProduct) {
			generateDifferentiatedGroups(menuProduct);
			const productSelections = self.findOrCreateProductSelection(menuProduct.id);
			return {
				product: menuProduct,
				productSelections,
				quantity: productSelections.reduce((carry, selection) => carry + selection.quantity, 0)
			};
		}
		return null;
	}
};
